import { Dictionary } from 'lodash';
import React from 'react';
import { DietaryDetails, OrderShefFragment } from 'src/gqlReactTypings.generated.d';
import { DescriptionCard } from 'src/pages/consumer/order/components/ShefDescriptionCards/DescriptionCard';
import { DietaryDisclosureModal } from 'src/pages/consumer/order/components/ShefDescriptionCards/verified-dietary/DietaryDisclosureModal';
import { DietaryHalal } from 'src/shared/design-system/Icon';
import { useModal } from 'src/shared/hooks/useModal';

interface DescriptionContent {
  headline: string;
  icon: React.ReactNode;
}

const descriptionContentBySurvey: Dictionary<DescriptionContent> = {
  'halal-compliance': {
    headline: 'Halal',
    icon: <DietaryHalal />,
  },
};

interface IProps {
  shef: OrderShefFragment;
  dietaryDetails: DietaryDetails;
}

export const DietaryDescriptionCard: React.FC<IProps> = ({ shef, dietaryDetails }) => {
  const { isShowing, show, hide } = useModal();
  const content = descriptionContentBySurvey[dietaryDetails.id];

  if (!content) return null;

  return (
    <>
      <DescriptionCard
        headline={content.headline}
        icon={content.icon}
        description={dietaryDetails.summaryDisplay}
        onClick={show}
      />
      {isShowing && (
        <DietaryDisclosureModal shef={shef} dietaryDetails={dietaryDetails} isShowing={isShowing} onClose={hide} />
      )}
    </>
  );
};
